import React from 'react';
import Loadable from 'react-loadable';
import ComponentLoading from 'components/ComponentLoading/ComponentLoading';
import ContainerErrorBoundary from 'components/ContainerErrorBoundary/ContainerErrorBoundary';
var LoadablePartnerSettings = Loadable({
  loader: function loader() {
    return import('../PartnerSettingsWrap.jsx');
  },
  loading: ComponentLoading
});
export default function WrappedLoadable(props) {
  return /*#__PURE__*/React.createElement(ContainerErrorBoundary, null, /*#__PURE__*/React.createElement(LoadablePartnerSettings, props));
}